import PropertiesModule from "./store";
import store from "@/store";

export default [
  {
    path: "/properties",
    component: () => import("./moduleLayout.vue"),
    beforeEnter(to, _, next) {
      if (!store.hasModule("Properties"))
        store.registerModule("Properties", PropertiesModule);
      next();
    },
    children: [
      {
        path: "vehicles",
        name: "vehicles",
        component: () => import("./pages/vehicles/index.vue"),
        meta: {
          pageTitle: "الآليات",
          slug: "ngo_vehicles",
          instructionsSlug: "vehicles",

          breadcrumb: [
            {
              text: "الممتلكات",
              active: true,
            },
            {
              text: "الآليات",
              active: true,
            },
          ],
        },
      },
      {
        path: "real-estates",
        name: "real-estates",
        component: () => import("./pages/real-estates/index.vue"),
        meta: {
          pageTitle: "العقارات",
          slug: "ngo_real-estates",
          instructionsSlug: "real-estates",
          breadcrumb: [
            {
              text: "الممتلكات",
              active: true,
            },
            {
              text: "العقارات",
              active: true,
            },
          ],
        },
      },
    ],
  },
];
